import homeLottie from "../assets/nav/home.json";
import resourcesLottie from "../assets/nav/resources.json";
import statsLottie from "../assets/nav/stats.json";

export const navAnimatedIcons = {
  home: {
    lottieData: homeLottie,
    durationMs: 3050,
  },
  resources: {
    lottieData: resourcesLottie,
    durationMs: 2050,
  },
  stats: {
    lottieData: statsLottie,
    durationMs: 3050,
  },
} as const;
